import { JsonObject, JsonProperty } from 'json2typescript';
import { CaseSession } from '../hearings/caseSession';
import { ExpertSession } from '../hearings/expertSession';
import { ExpertSessionSearchResults } from '../hearings/hearingSearchResults';
import { User } from '../users/user';

export enum EventTypeEnum {
    VACATION = 1,
    HOLIDAY = 2,
    MEETING = 3,
    CASE = 4,
    EXPERT = 5,
    CASUALLEAVE = 6,
    SICKLEAVE = 7,
    OTHER = 8,
}

export const colors = {
    1: '#A0A4A8',
    2: '#F6A609',
    3: '#2AC769',
    4: '#FB4E4E',
    5: '#56CCF2',
    6: '#59bfa0',
    7: '#6f3189',
    8: ''

}

export const eventTypes: { name: string, value: number }[] = [
    { name: 'Vacation', value: 1 },
    { name: 'Meeting', value: 3 },
    { name: 'Casual Leave', value: 6 },
    { name: 'Sick Leave', value: 7 }
]

@JsonObject('Event')
export class Event {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('title', String, true)
    title = null;

    @JsonProperty('start', String, true)
    start = null;

    @JsonProperty('end', String, true)
    end = null;

    @JsonProperty('description', String, true)
    description = null;

    @JsonProperty('location', String, true)
    location = null;

    @JsonProperty('event_type', Number, true)
    eventType: EventTypeEnum = undefined;

    @JsonProperty('all_day', Boolean, true)
    allDay = false;

    // list of user ids - write only
    @JsonProperty('invitees', [Number], true)
    invitees: number[] = [];

    // read only
    @JsonProperty('invited_users', [User], true)
    invitedUsers: User[] = [];

    @JsonProperty('case_session', Number, true)
    caseSessionId: number = undefined;

    @JsonProperty('expert_session', Number, true)
    expertSessionId: number = undefined;

    @JsonProperty('created_by', User, true)
    createdBy: User | null = null;
}